
import { Telemetry, ValidTelemetryEvent } from '~src/commonInfra/services/Telemetry';

export const connectDisconnectEventType = 'site_slack_connection';
export const userReturnFromSlackEventType = 'user_return_from_slack';
export const commentingMentionNotificationType = 'commentingMention';
export const dataDrivenAlertNotificationType = 'dataDrivenAlert';
export const sharingNotificationType = 'sharing';
export const editAlertLinkType = 'editAlert';
export const viewLinkType = 'view';


export interface ConnectToSlackEvent extends ValidTelemetryEvent<ConnectToSlackEvent> {
  type: string;
  user_id: string;
  site_luid: string;
  is_connect: boolean; // If value is true, this is a "Connect to Slack" event. If value is false, it is a "Disconnect from Slack" event
}

export interface ReturnLinkFromSlackEvent extends ValidTelemetryEvent<ReturnLinkFromSlackEvent> {
  type: string;
  user_id: string;
  site_luid: string;
  notification_type: string;
  link_type: string;
}

interface ConnectDisconnectSlackEventParams {
  userId: string;
  siteLuid: string;
  connectToSlack: boolean;
}

export function sendConnectToSlackTelemetry(params: ConnectDisconnectSlackEventParams) {
  Telemetry.sendEvent<ConnectToSlackEvent>({
    type: connectDisconnectEventType,
    user_id: params.userId,
    site_luid: params.siteLuid,
    is_connect: params.connectToSlack
  });
}

interface ReturnFromSlackEventParams {
  userId: string;
  siteLuid: string;
  notificationType: string;
  linkType: string;
}

export function sendReturnFromSlackTelemetry(params: ReturnFromSlackEventParams) {
  Telemetry.sendEvent<ReturnLinkFromSlackEvent>({
    type: userReturnFromSlackEventType,
    user_id: params.userId,
    site_luid: params.siteLuid,
    notification_type: params.notificationType,
    link_type: params.linkType,
  });
}